module.exports = __webpack_public_path__ + "static/media/29_A.28988825.png";